// @flow

import { useState, useEffect } from 'react';
import { useUserInputValidationError } from '@tectonics/prs/validation';

const state: { [inputName: string]: boolean } = {};

export function useMustShow(inputName: string): boolean {
  const [mustShow, setMustShow] = useState(state[inputName]);
  const validationError = useUserInputValidationError(inputName);

  useEffect(() => {
    if (!mustShow && !!validationError) {
      state[inputName] = true;
      setMustShow(state[inputName]);
    }
  }, [validationError]);

  return mustShow;
}
